<template>
  <div class="flex flex-wrap mt-1 w-full overflow-hidden">
    <div class="w-12/12 column px-gap carousel--product">
      <Swiper
        v-if="modules?.media"
        ref="productSwiper"
        :options="productSwiperOptions"
        class="w-full swiper__slide"
      >
        <SwiperSlide
          v-for="(slide, index) in modules?.media"
          :key="index"
          class="flex justify-center items-center"
        >
          <PictureWrapper
            v-if="slide?.sys?.contentType?.sys?.id === 'image'"
            :image="slide.fields"
            data-not-lazy
            stuff
          />
          <img
            v-else-if="slide?.sys?.contentType?.sys?.id === 'video'"
            :src="`https://img.youtube.com/vi/${slide.fields.id}/hqdefault.jpg`"
            data-not-lazy
          />
        </SwiperSlide>
      </Swiper>
      <div v-if="modules.media" class="swiper__dots mt-2 flex justify-center">
        <ProductCarouselDot
          v-for="(slide, index) in modules?.media"
          :key="index"
          :slide="slide"
          :index="index"
          :active="active"
          :last="modules && modules.media ? modules.media.length : 0"
          class="swiper__dot border-1 cursor-pointer mr-1"
          @clicked="goToSlide(index)"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.carousel--product ::v-deep {
  .swiper-slide {
    height: auto;
    max-height: 450px;

    img {
      max-width: 540px;
      max-height: 320px;
    }

    @media (max-width: 736px) {
      img {
        max-width: 330px;
      }
    }
  }
  .swiper-wrapper {
    @apply h-full;
    height: 100%;
  }
}

.module__video-modal {
  @apply w-12/12 mt-3 ml-0;
  width: 100%;
}

.swiper__dot {
  height: 60px;
  width: 60px;
  overflow: hidden;

  @media only screen and (min-width: 766px) {
    height: 80px;
    width: 80px;
  }

  ::v-deep img {
    max-width: 200%;
  }
}
@media only screen and (max-width: 766px) {
  .swiper__dots {
    width: 110%;
    overflow: scroll;
    height: 80px;
    flex-grow: 1;
    flex-basis: 0;
    flex-shrink: 0;
  }
  .swiper__dots::-webkit-scrollbar {
    display: none;
  }
}
@media only screen and (max-width: 450px) {
  .swiper__dots {
    margin-top: 20px;
    margin-left: -11px;
    padding-left: 25%;
    padding-right: 30px;
    margin-bottom: 50px;
  }
}
</style>
<script>
import get from "../../mixins/get.js";
import PictureWrapper from "./PictureWrapper";
import ProductCarouselDot from "./ProductCarouselDot";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";

import "swiper/swiper-bundle.min.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
    PictureWrapper,
    ProductCarouselDot
  },
  mixins: [get],
  props: {
    modules: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      active: 0,
      productSwiperOptions: {
        loop: false,
        lazy: {
          loadPrevNext: true
        },
        slidesPerView: 1,
        allowTouchMove: false
      }
    };
  },
  computed: {
    productSwiper() {
      return this.$refs.productSwiper.$swiper;
    }
  },
  methods: {
    goToSlide(index) {
      this.active = index;
      this.productSwiper.slideTo(index);
    }
  }
};
</script>
